import base from "../baseurl";
import token from "../getTk";

const showAll = async (id) => {
  const tokenA = token.get();
  const api = base.extend({
    hooks: {
      beforeRequest: [
        (request) => {
          request.headers.set("jwt", `${tokenA}`);
        },
      ],
    },
  });
  console.log(id);
  const show = await api
    .post("company-forms/delete", {
      json: { id },
    })
    .json();
  return show;
};

export default showAll;
